export default __webpack_public_path__ + "static/media/02.e5ef0e44.jpg";